// @ts-strict-ignore

type CaseConverter = (s: string) => string;
export const camelToSnakeCase: CaseConverter = (str: string) => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

/** Converts a snake-cased string to camel case while preserving leading underscores */
export const snakeToCamelCase: CaseConverter = (str: string) => {
  const hasLeadingUnderscore = str.startsWith('_');
  const withoutLeadingUnderscore = str.replace(/^_*/, '');
  const camelCased = withoutLeadingUnderscore.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  return hasLeadingUnderscore ? `_${camelCased}` : camelCased;
};


// Recursively convert the keys in an object using the passed `converter`
function convertKeys(obj: Object, converter: CaseConverter) {
  if (typeof obj !== 'object' || obj === null) return obj;

  if (Array.isArray(obj)) {
    return obj.map(item => convertKeys(item, converter));
  }

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      converter(key),
      convertKeys(value, converter),
    ]),
  );
}


export function toCamelCase(obj: Object) {
  return convertKeys(obj, snakeToCamelCase);
}

export function toSnakeCase(obj: Object) {
  return convertKeys(obj, camelToSnakeCase);
}


export function getNormalizedHeaderValue(headers: Headers, headerName: string) {
  const lowercaseHeaders = new Headers();
  for (const [k, v] of headers) {
    lowercaseHeaders.set(k.toLocaleLowerCase(), v);
  }

  return lowercaseHeaders.get(headerName.toLocaleLowerCase());
}
